import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { dotIcon } from "./Dot.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const Dot = t0 => {
  const $ = _c(6);
  const {
    color: t1,
    size: t2
  } = t0;
  const color = t1 === undefined ? "gray" : t1;
  const size = t2 === undefined ? "m" : t2;
  let t3;
  if ($[0] !== color || $[1] !== size) {
    t3 = dotIcon({
      color,
      size
    });
    $[0] = color;
    $[1] = size;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsx("circle", {
      cx: "4",
      cy: "4",
      r: "3",
      fill: "currentColor"
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = /*#__PURE__*/_jsx("svg", {
      className: t3,
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "8",
      viewBox: "0 0 8 8",
      fill: "none",
      children: t4
    });
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
//# sourceMappingURL=Dot.js.map